<template>
  <div :style="{ height }" class="h-screen w-screen relative font-nunito flex flex-col md:flex-row">
    <div :class="open ? 'h-2/3' : 'h-10'"
      class="transition-all duration-500 w-full overflow-hidden -mt-10 md:mt-0 md:static md:h-auto lg:absolute lg:top-8 lg:left-8 md:w-80 lg:bottom-8 z-10 order-2 md:order-1">
      <div class="bg-white py-6 px-4 rounded-t-2xl md:rounded-r-2xl lg:rounded-2xl h-full shadow-sm flex flex-col">
        <button title="Toggle Panel" @click="open = !open" class="block md:hidden p-2 w-16 mx-auto -mt-3 mb-1">
          <span class="block w-full h-1 rounded-full bg-neutral-50">
          </span>
        </button>
        <div class="h-0 flex-grow md:h-full relative">
          <Transition name="fade-left-alt">
            <VMapFilters v-if="filters.active" :data="filters" @apply-filters="onSetFilters"
              @go-to-back="filters.active = null"></VMapFilters>
            <template v-else>
              <VMapCardDetail v-if="active" :item="active" @go-to-back="active = null" :icon="icon.icon"
                :key="`detail-${_uid}-${active.lat}-${active.lon}`">
                <template #title="{ value }">
                  {{ filterCapitalize(value) }}
                </template>
                <template #tools>
                  <div v-if="current" class="text-sm leading-snug px-2 py-1 bg-blue-light-100 rounded-lg font-bold">
                    {{ filterDistance(onDistanceRatio(current, { lat: Number(active.lat), lng: active.lon })) }}
                  </div>
                </template>
              </VMapCardDetail>
              <div v-else class="flex flex-col gap-6 h-full">
                <div class="flex flex-col gap-4">
                  <div class="flex gap-2">
                    <div class="w-1 flex-grow">
                      <!--<select v-model="select" class="w-full">
                        <option :value="option.value" v-for="(option, index) in options">{{ option.text }}</option>
                      </select>-->
                      <VMapSlide :items="options" v-model="select"></VMapSlide>
                    </div>
                  </div>
                  <div class="flex gap-2">
                    <div class="w-1 flex-grow">
                      <input class="bg-[#F4F5F5] px-2 py-1.5 text-base rounded-lg leading-tight w-full" type="text"
                        placeholder="Buscar con maps..." v-model="search">
                    </div>
                    <template v-if="!select.includes('business')">
                      <button @click="filters.active = true"
                        class="py-1 px-2 rounded-lg bg-primary-0 text-white leading-none transition hover:bg-primary-dark-40"
                        title="Filter">
                        <i class="w-5 block" v-icon:filter></i>
                      </button>
                      <button @click="onClearFilters" v-if="isClearable"
                        class="py-1 px-2 rounded-lg text-primary-0 border border-current bg-white leading-none transition hover:bg-primary-0 hover:text-white"
                        title="Clear">
                        <i class="w-5 block" v-icon:close-alt></i>
                      </button>
                    </template>
                  </div>
                  <div class="flex gap-4">
                    <button v-if="!select.includes('business')" @click="near = false" :class="{ 'grayscale': near }"
                      class="w-1 flex-grow py-2 px-5 rounded-lg bg-blue-light-100 text-blue-dark-80 leading-none transition hover:grayscale-0">
                      Mejor precio
                    </button>
                    <button @click="onNear" :class="{ 'grayscale': !near }"
                      class="w-1 flex-grow py-2 px-5 rounded-lg bg-blue-light-100 text-blue-dark-80 leading-none transition hover:grayscale-0">
                      Mas cercano
                    </button>
                  </div>
                </div>
                <div class="flex flex-col gap-4 h-1 flex-grow overflow-auto">
                  <template v-if="itemsList.length">
                    <div v-for="(item, index) in itemsList" :key="`card-map-${_uid}-${index}-${item.lat}-${item.lon}`"
                      class="bg-[#F4F5F5] rounded-lg p-3 flex flex-col gap-3">
                      <div class="flex items-center gap-2">
                        <h3 class="text-base font-semibold font-nunito w-1 flex-grow">{{ filterCapitalize(item.nom) }}
                        </h3>
                        <button
                          class="py-2 px-5 rounded-lg bg-primary-0 text-white leading-none transition hover:bg-primary-dark-40"
                          @click="onSetActive(item)">
                          Ir
                        </button>
                      </div>
                      <div class="grid grid-cols-2 gap-2">
                        <div class="flex gap-1.5">
                          <template v-if="item.price && item.price.length">
                            <div class="w-0.5 h-full bg-primary-0">
                            </div>
                            <div class="w-1 flex-grow">
                              <VMapCardProduct v-if="item.price" :list="item.price"></VMapCardProduct>
                            </div>
                          </template>
                          <template v-else>
                            <div class="w-0.5 h-full bg-green-dark-40">
                            </div>
                            <div class="w-1 flex-grow">
                              <div class="flex flex-col bg-white text-xs items-start justify-center px-2 py-1 h-full">
                                <b>Abierto</b>
                              </div>
                            </div>
                          </template>
                        </div>
                        <div class="flex items-center justify-end">
                          <span v-if="current"
                            class="text-base leading-snug px-2 py-1 bg-blue-light-100 rounded-lg font-bold">
                            {{ filterDistance(onDistanceRatio(current, { lat: Number(item.lat), lng: item.lon })) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <div v-else class="text-base border-l-4 border-primary-0 p-8 bg-[#F4F5F5] font-medium font-nunito">
                    No se encontraron negocios o estaciones de servicios disponibles
                  </div>
                </div>
              </div>
            </template>
          </Transition>
        </div>
      </div>
    </div>
    <div class="h-1 w-full flex-grow md:w-1 lg:w-full md:h-full order-1 md:order-2">
      <VMapCanvas :mapId="mapId" :center="center">
        <template #default>
          <VMarker v-if="current" v-bind="{ position: current, mark: true }"></VMarker>
          <VMarker v-for="(item, index) in itemsList" @click="onSetActive(item)" :color="onSetColor(icon.icon)"
            :active="isActive(active, item)" :key="`marker-${_uid}-${index}-${item.lat}-${item.lon}`"
            v-bind="{ position: { lat: item.lat, lng: item.lon } }">
            <template v-if="item.price && item.price.length">
              {{ filterPrice(item.price[0].retailPrice) }}
            </template>
            <template v-else-if="icon.icon">
              <i class="w-5 block" v-icon:[onSetIcon(icon.icon)]></i>
            </template>
            <template v-else>
              {{ item.tip }}
            </template>
          </VMarker>
          <!--
          -->
        </template>
      </VMapCanvas>
    </div>
    <Transition name="fade">
      <VMapModal v-if="modal" @close="modal = false"></VMapModal>
    </Transition>
  </div>
</template>

<script>
import VMapCardProduct from "./VMapCardProduct.vue"
import VMapCanvas from "./VMapCanvas.vue"
import VMarker from "./VMarker.vue"
import VMapCardDetail from "./VMapCardDetail.vue"
import VMapFilters from "./VMapFilters.vue"
import VMapSlide from "./VMapSlide.vue"
import VMapModal from "./VMapModal.vue"
export default {
  name: "VMapFullScreenContent",
  components: {
    VMapCardProduct, VMapCanvas, VMarker, VMapCardDetail, VMapFilters, VMapSlide, VMapModal
  },
  props: {
    options: {
      type: Array,
      require: true
    },
    endpointEds: {
      type: String,
      require: true
    },
    mapId: {
      type: String,
      require: true
    },
    endpointBusiness: {
      type: String,
      require: true
    }
  },
  inject: ['geometry'],
  data() {
    return {
      height: "0px",
      open: true,
      modal: false,
      current: null,
      near: false,
      loading: true,
      active: null,
      eds: [],
      business: [],
      markers: [],
      search: "",
      filters: {
        active: false,
        services: {
          options: [],
          value: []
        },
        prices: {
          options: [],
          value: []
        },
        programs: {
          options: [],
          value: []
        }
      },
      select: 'eds',
      center: {
        lat: 0,
        lng: 0
      },
    }
  },
  computed: {
    isClearable() {
      return this.search || this.filters.prices.value.length || this.filters.services.value.length || this.filters.programs.value.length;
    },
    icon() {
      const item = this.options.find(item => item.value == this.select);
      const result = { icon: item.icon };
      return result;
    },
    items() {
      const select = this.select.split("_");
      return select.includes("eds") ? this.eds : select.includes("business") ? this.business : [];
    },
    itemsList() {
      const select = this.select.split("_");
      const list = JSON.parse(JSON.stringify(this.items));
      const result = [];
      list.forEach(item => {
        const res = [this.textNormalize(item.nom).includes(this.textNormalize(this.search))];

        if (select) {
          const value = select[2];
          if (select.includes("price")) {
            res.push(Boolean(item.price.find(p => p.id == value)));
          } else if (select.includes("services")) {
            res.push(Boolean(item.services.find(p => p.code == value)));
          } else if (select.includes("type")) {
            res.push(item.tip == value);
          }
        }

        if (select.includes("eds") && item.price && this.filters.prices.value.length) {
          item.price = item.price.filter(p => this.filters.prices.value.includes(p.id));
          res.push(Boolean(item.price.length));
        }
        if (select.includes("eds") && item.services && this.filters.services.value.length) {
          item.services = item.services.filter(s => this.filters.services.value.includes(s.code));
          res.push(Boolean(item.services.length));
        }

        if (this.near) {
          const dist = this.onDistanceRatio(this.current, { lat: Number(item.lat), lng: Number(item.lon) })
          res.push(dist < this.ratio);
        }

        if (select.includes("price") && select[select.length - 1] == '4') {
          item.price.sort((a, b) => (a.id == '4' || a.id < b.id) ? -1 : a.id > b.id ? 1 : 0)
        }

        if (!res.includes(false)) {
          result.push(item);
        }
      });


      if (this.near) {
        result.sort((a, b) => {
          const distA = this.onDistanceRatio(this.current, { lat: a.lat, lng: a.lon })
          const distB = this.onDistanceRatio(this.current, { lat: b.lat, lng: b.lon })
          return distA < distB ? -1 : distA > distB ? 1 : 0
        })
      }

      return result;
    },
    ratio() {
      return this.near ? 10000 : Infinity
    }
  },
  async mounted() {

    await this.getList();

    this.getGeolocation()
    this.onSetHeight();
    window.addEventListener("resize", () => {
      this.onSetHeight();
    })
    this.loading = false;

  },
  methods: {
    onSetHeight() {
      const $header = document.querySelector("header");
      let $wHeight = window.innerHeight;
      if ($header) {
        $wHeight = ($wHeight - $header.offsetHeight);
      }
      this.height = $wHeight + "px";
    },
    onClearFilters() {
      this.search = "";
      this.filters.prices.value = [];
      this.filters.services.value = [];
      this.filters.programs.value = [];
    },
    onSetColor(icon) {
      return 'icon-voltex' == icon ? 'Azul' : 'icon-gazel' == icon ? 'Azul oscuro' : 'Rojo';
    },
    onSetIcon(icon) {
      return icon == 'icon-voltex' ? 'lightning' : icon
    },
    onSetFilters({ prices, services, programs }) {
      this.filters.active = false;
      this.filters.prices.value = prices;
      this.filters.services.value = services;
      this.filters.programs.value = programs;
    },
    isActive(active, item) {
      return active && active.lon == item.lon && active.lat == item.lat;
    },
    async getList() {
      try {

        await fetch(this.endpointEds)
          .then(res => res.json())
          .then(res => {
            this.onGetEds(res);
          });

        await fetch(this.endpointBusiness)
          .then(res => res.json())
          .then(res => {
            this.onGetBusiness(res);
          })

      } catch (e) {
        console.error(e);
      }
    },
    onGetEds(res) {

      const services = [];
      const prices = [];
      const programs = [];
      const result = res.map(item => {
        item.services?.forEach((service) => {
          if (!services.find(f => f.code == service.code) && service.name && !['Lubriplus'].includes(service.name))
            services.push(service);
        });

        item.programs?.forEach((program) => {
          if (!programs.find(f => f.code == program.code) && program.name && !['Club Terpel', 'Club Gazel'].includes(program.name))
            programs.push(program);
        });

        item.price?.forEach((price) => {
          if (!prices.find(f => f.id == price.id))
            prices.push(price);
        });
        item.price.sort((a, b) => a.id < b.id ? -1 : a.id > b.id ? 1 : 0);
        return item
      });

      services.sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0);
      this.filters.services.options = services;

      prices.sort((a, b) => a.id < b.id ? -1 : a.id > b.id ? 1 : 0);
      this.filters.prices.options = prices;

      programs.sort((a, b) => a.code < b.code ? -1 : a.code > b.code ? 1 : 0);
      this.filters.programs.options = programs;


      result.sort((a, b) => {
        if (a.price.length && b.price.length) {
          return a.price[0].retailPrice < b.price[0].retailPrice ? -1 : a.price[0].retailPrice > b.price[0].retailPrice ? 1 : 0
        }else {
          return -1
        }
      })

      this.onCenter(result[0]);
      this.eds = result;
      localStorage.setItem("eds", JSON.stringify(result));
    },
    onGetBusiness(res) {
      this.business = res;
      localStorage.setItem("business", JSON.stringify(res));
    },
    getGeolocation(callback) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          ({ coords }) => {
            this.current = { lat: coords.latitude, lng: coords.longitude };
            this.center = { lat: coords.latitude, lng: coords.longitude };
            if (callback)
              callback();
          },
          (error) => {
            console.error(error);
            if (error.code === 1) {
              this.modal = true;
            }
          }
        );
      }
    },
    onDistanceRatio(center, position) {
      return this.geometry.spherical.computeDistanceBetween(center, position);
    },
    filterCapitalize(str) {
      const value = str.split(" ");
      return value.map(item => item == 'EDS' ? item : item.replace(/\D/g, (r, i) => 0 == i ? r.toUpperCase() : r.toLowerCase())).join(" ");
    },
    filterPrice(str) {
      return str.toLocaleString("es-CO", {
        style: 'currency',
        currency: "COP",
        maximumFractionDigits: 0
      })
    },
    filterDistance(str) {
      const num = str / 1000;
      return num.toLocaleString("es-CO", {
        style: 'unit',
        unit: "kilometer",
        maximumFractionDigits: 1
      })
    },
    onNear() {
      if (this.current) {
        this.near = !this.near;
        this.center = this.current;
      } else {
        this.getGeolocation(() => {
          this.near = true;
        });
      }
    },
    onSetActive(item) {
      this.open = true;
      this.active = this.items.find(i => i.lon == item.lon && i.lat == item.lat);
      this.onCenter(item);
    },
    onCenter({ lat, lon }) {
      this.center = { lat, lng: lon };
    },
    textNormalize(str) {
      return str.normalize("NFD").replace(/[\u0300-\u036f]/, "").toLowerCase();
    },
  }
}
</script>